var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoticeRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.333A7.312 7.312 0 01.667 8 7.312 7.312 0 018 .667 7.312 7.312 0 0115.333 8 7.312 7.312 0 018 15.333zM8 2C4.667 2 2 4.667 2 8s2.667 6 6 6 6-2.667 6-6-2.667-6-6-6z",
    fill: "#ED1B2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.667c-.4 0-.667-.267-.667-.667V5.333c0-.4.267-.666.667-.666s.667.266.667.666V8c0 .4-.267.667-.667.667zM8 11.333a.605.605 0 01-.467-.2.605.605 0 01-.2-.466c0-.067 0-.2.067-.267s.067-.133.133-.2c.2-.2.467-.267.734-.133.066 0 .066 0 .133.066 0 0 .067.067.133.067.067.067.134.133.134.2v.267c0 .066 0 .2-.067.266-.067.067-.067.134-.133.2a.605.605 0 01-.467.2z",
    fill: "#ED1B2D"
  })));
}

export default SvgIconNoticeRed;